// extracted by mini-css-extract-plugin
export var active = "_l2-2";
export var recordingDot = "_l2-1";
export var recordingIndicator = "_l2-0";